import { Reducer } from "redux";
import { IWorkflowItemStep } from "../../../../common/sharedTypes";
import { CheckersQueueItem } from "../business-objects/common";
import * as actionTypes from "./actionTypes";

export interface ICheckersQueueState {
  workflowItemSteps: IWorkflowItemStep[];
  openWorkflowItemStep: IWorkflowItemStep;
  image: Uint8Array;
  frontSheet: Uint8Array;
  form40: Uint8Array;
  currentImageWindow: any;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
  queueItems: CheckersQueueItem[];
}

const initialState: ICheckersQueueState = {
  workflowItemSteps: [],
  openWorkflowItemStep: null,
  image: null,
  frontSheet: null,
  form40: null,
  currentImageWindow: null,
  loadingWorkflowSteps: false,
  totalWorkflowItemSteps: 0,
  queueItems: null,
};
var toUint8Array = require("base64-to-uint8array");

const getBase64Payload = (value: any): string => {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    const dataUrlMatch = value.match(/^data:[^;]+;base64,(.*)$/);
    const base64 = dataUrlMatch ? dataUrlMatch[1] : value;
    const normalized = base64.replace(/\s/g, "").replace(/-/g, "+").replace(/_/g, "/");
    return normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
  }

  return getBase64Payload(value.pdf || value.data || value.frontSheetData || value.image);
};

const toPdfBytes = (value: any): Uint8Array => {
  if (!value) {
    return null;
  }

  if (value instanceof Uint8Array) {
    return value;
  }

  if (value instanceof ArrayBuffer) {
    return new Uint8Array(value);
  }

  const base64 = getBase64Payload(value);
  if (!base64) {
    return null;
  }

  try {
    return toUint8Array(base64);
  } catch (ex) {
    console.error("Invalid PDF base64 payload", ex);
    return null;
  }
};

const reducer: Reducer<ICheckersQueueState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case actionTypes.LOADING_WORKFLOW_STEPS: {
      return { ...state, loadingWorkflowSteps: action.value };
    }
    case actionTypes.TOTAL_WORKFLOW_STEPS: {
      return { ...state, totalWorkflowItemSteps: action.value };
    }
    case actionTypes.SEARCH_REPORTS: {
      let _state = { ...state };
      _state = { ...state, workflowItemSteps: action.value };
      return _state;
    }
    case actionTypes.SEARCH_REPORTS_PAGED: {
      return { ...state, queueItems: action.value };
    }
    case actionTypes.OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case actionTypes.ASSIGN_AND_OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case actionTypes.UNASSIGN: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      _state.queueItems = [
        ..._state.queueItems.map((item) =>
          item.id == action.value.id ? new CheckersQueueItem(action.value) : item
        ),
      ];
      return _state;
    }
    case actionTypes.REMOVE_FROM_RESULTS: {
      let _state = { ...state };
      _state.workflowItemSteps = _state.workflowItemSteps.filter(
        (item) => item.id != action.value.id
      );
      _state.queueItems = _state.queueItems.filter((item) => item.id != action.value.id);
      return _state;
    }
    case actionTypes.GET_IMAGE: {
      return { ...state, image: toPdfBytes(action.value) };
    }
    case actionTypes.GET_FORM_40: {
      return { ...state, form40: toPdfBytes(action.value) };
    }
    case actionTypes.GET_FRONTSHEET: {
      return { ...state, frontSheet: toPdfBytes(action.value) };
    }
    case actionTypes.COMPLETE_CHECKERS: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }

    case actionTypes.LOAD_CHECKERS_IMAGE: {
      let _state = { ...state };
      const fileUrl = action.value.fileUrl;
      const forceNewWindow = action.value.forceNewWindow;
      if (!_state.currentImageWindow || forceNewWindow) {
        _state.currentImageWindow = window.open(fileUrl, "_blank", "width=1000,height=800");
        _state.currentImageWindow.onbeforeunload = function () {
          console.log("unloading window");
          _state.currentImageWindow = null;
        };
      } else {
        console.log(_state.currentImageWindow);
        _state.currentImageWindow.location.href = fileUrl;
      }
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
